import React, { useState, useEffect } from "react";
import Layout from "../../components/layout/Layout";
import TargetsMissedTable from "../../containers/TargetsMissedTable";
import TrackInitiationsTable from "../../containers/TrackInitiationsTable";
import PublicationMissedTable from "../../containers/PublicationMissedTable";
import { useSelector } from "react-redux";
import CorporatePlansSummaryTable from "../../containers/CorporatePlansSummaryTable";
import {
    useGetAnalystListQuery,
    useGetDynamicFilterOptionsQuery,
} from "../../redux/service/modules/dashboard";
import { formatLabel } from "../../utils/commonUtils";
import CommonNavigator from "../../components/common/CommonNavigator";
import { useGetUserListQuery } from "../../redux/service/modules/sales";

const Dashboard = () => {
    const dateRange = useSelector((state) => state.date);
    const { data: userList } = useGetUserListQuery();

    const [analystFilter, setAnalystFilter] = useState(null);
    useEffect(() => {
        if (userList) {
            setAnalystFilter({
                name: "analystName",
                label: "Analyst Name",
                key: "analyst",
                options: userList.map((analyst) => ({
                    label: analyst.username,
                    id: analyst.id,
                })),
                multiSelect: true,
            });
        }
    }, [userList]);

    return (
        <Layout>
            <div className="flex flex-col gap-2">
                <CommonNavigator title={"Research Periodicity"} />
                <div className="grid grid-cols-2 gap-2 auto-rows-auto">
                    <div className="h-full">
                        <TargetsMissedTable
                            initialDateRange={dateRange}
                            filters={analystFilter ? [analystFilter] : []}
                        />
                    </div>
                    <div className="h-full">
                        <TrackInitiationsTable
                            initialDateRange={dateRange}
                            filters={analystFilter ? [analystFilter] : []}
                        />
                    </div>
                    <div className="h-full">
                        <PublicationMissedTable
                            initialDateRange={dateRange}
                            filters={analystFilter ? [analystFilter] : []}
                        />
                    </div>
                    <div className="h-full">
                        <CorporatePlansSummaryTable
                            initialDateRange={dateRange}
                            filters={analystFilter ? [analystFilter] : []}
                        />
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default Dashboard;
